import {Injectable} from '@angular/core';
import {Title, Meta, MetaDefinition} from '@angular/platform-browser';

const GENERAL_TITLE = 'Live Booking Portal';

@Injectable()
export class TitleService {

    constructor(private title: Title, private meta: Meta) {
    }

    set(title: string, remove_general_title?: boolean): void {
        this.title.setTitle([title, !remove_general_title && GENERAL_TITLE].filter(Boolean).join(' — '));
    }

    addMeta(tags: MetaDefinition[]) {
        this.meta.addTags(tags)
    }
}
